var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRetoma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "retoma") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elementos_Escuro",
    transform: "translate(-420, -3917)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 2.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M440.246704,3928.51722 L445,3923.75857 L440.246704,3919 M422,3923.75857 L445,3923.75857 M426.753296,3932.48278 L422,3937.24143 L426.753296,3942 M445,3937.24135 L422,3937.24135",
    id: "retoma"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRetoma);
export default __webpack_public_path__ + "static/media/retoma.5ece59da608d651c23f27d45c22f26e9.svg";
export { ForwardRef as ReactComponent };